const US_ZIP_PATTERN = /^\d{5}$|^\d{5}-\d{4}$/
const US_COUNTRY_ID = 223

export const isValidUsZipCode = (zip: string | null | undefined): boolean => {
  if (zip == null || zip === '') return false
  return US_ZIP_PATTERN.test(zip)
}

export const isValidUsStateId = (stateId: number | null | undefined): boolean => {
  if (stateId == null) return false
  return stateId > 0
}

export interface UsAddressSlotForValidation {
  building?: string | null
  addressOne?: string | null
  state: { id: number } | null
  country: { id: number } | null
  zipCode: string | null
}

export const usAddressSlotError = (
  slot: UsAddressSlotForValidation,
  isSecondary: boolean
): string | null => {
  if (slot.country?.id !== US_COUNTRY_ID) return null

  if (isSecondary) {
    const populated = (slot.building ?? '').trim() !== '' || (slot.addressOne ?? '').trim() !== ''
    if (!populated) return null
  }

  if (!isValidUsStateId(slot.state?.id)) {
    return isSecondary ? 'Please select a secondary state.' : 'Please select a primary state.'
  }

  if (!isValidUsZipCode(slot.zipCode)) {
    return isSecondary
      ? 'Please enter a secondary 5-digit or 9-digit zip code.'
      : 'Please enter a primary 5-digit or 9-digit zip code.'
  }

  return null
}

export const usAddressIsValid = (
  address: {
    primary: UsAddressSlotForValidation
    secondary: UsAddressSlotForValidation
  },
  showErrorMessage: (message: string) => void
): boolean => {
  const error = usAddressSlotError(address.primary, false) ?? usAddressSlotError(address.secondary, true)
  if (error == null) return true
  showErrorMessage(error)
  return false
}
